import { AlertDialog } from './AlertDialog';
import { ShowAlertDialogContext } from './context';
import { useAlertDialogValue } from './useAlertDialogValue';

type Props = {
  children: React.ReactNode;
};

export const AlertDialogProvider: React.FC<Props> = props => {
  const { alertDialogProps, ref, showAlertDialog, closeAlertDialog } = useAlertDialogValue();

  return (
    <ShowAlertDialogContext.Provider value={{ showAlertDialog }}>
      {alertDialogProps && (
        <AlertDialog {...alertDialogProps} ref={ref} onClose={closeAlertDialog} />
      )}
      {props.children}
    </ShowAlertDialogContext.Provider>
  );
};
